import { getClient } from './apollo';
import gql from 'graphql-tag';
import { CurrentUserFragment } from './component/GatedComponent';

export const serverUrl = process.env.REACT_APP_CMS_SERVER || 'http://cms-' + window.location.hostname;

const query = gql`
    ${CurrentUserFragment}
    query readStartup {
        readOneSiteConfig {
            ID
            AdminFee
            BondPercent
            CMBrandID
            CremationManagerDomain
            FuneralArrangerDomain
            #FuneralManagerDomain
            getDeathRegistrationPage
            getPrePlanRegistrationPage
            MVC2CMID
            MaxUploadBytes
            #ReactDeployment
            XeroAccountsFM
        }
        readOfficesUsernames {
            nodes {
                ID
                ForegroundColour
                IsRetired
                Logo
                OfficeColour
                RegistrantSuffix
                LegacyKey
                Title
                ... on OfficesUsername {
                    Branches {
                        nodes {
                            ID
                        }
                    }
                }
                ... on OfficesBranch {
                    BrandID
                }
            }
        }
        readCurrentUser {
            ...CurrentUserFragment
        }
    }
`;

export function getMaxUploadSize() {
    const readOneSiteConfig = getSiteConfig();
    return readOneSiteConfig.MaxUploadBytes || 2097152; // 2MB is typical server default
}

export function getDefaultCrematoriumID() {
    const readOneSiteConfig = getSiteConfig();
    return readOneSiteConfig.MVC2CMID || '6463'; // default AddressBook ID
}

/**
 * Retrieve the site config from cache.
 * If it has not loaded yet, catch the error and return null.
 * @returns {Object} the SiteConfig
 */
export function getSiteConfig() {
    let result = {};
    try {
        const data = getClient().readQuery({ query }) || {};
        if (data && data.readOneSiteConfig) {
            result = { ...data.readOneSiteConfig };
        }
    } catch (e) {
        // send back empty object
    }
    return result;
}

/**
 * Retrieve the offices from cache.
 * If it has not loaded yet, catch the error and return null.
 * @returns {{ID,Title,OfficeColour,RegistrantSuffix,LegacyKey,IsRetired,BrandID,Branches{nodes[]}[]} the list of brands and branches
 */
export function getOffices() {
    let result = [];
    try {
        const data = getClient().readQuery({ query }) || {};
        if (data && data.readOfficesUsernames) {
            result = data.readOfficesUsernames.nodes
                .map(node => ({ ...node }))
                .sort(({ Title: aTitle }, { Title: bTitle }) => (aTitle > bTitle ? 1 : -1));
        }
    } catch (e) {
        // send back empty array
    }
    return result;
}

/**
 * Retrieve the current user details from cache.
 * If it has not loaded yet, catch the error and return null.
 * @returns {ID,MyLastOfficeID,FirstName,Surname,Email} the user details
 */
export function getCurrentUser() {
    let result = {};
    try {
        const data = getClient().readQuery({ query }) || {};
        if (data && data.readCurrentUser) {
            result = { ...data.readCurrentUser };
        }
    } catch (e) {
        // send back empty object
    }
    return result;
}

export function loadSiteConfig() {
    return getClient().query({ query });
}

export function isLocalServer() {
    if (serverUrl.indexOf('.local') !== -1) return true;
    if (serverUrl.indexOf('.webdev') !== -1) return true;
    return false;
}

export function isLocalClient() {
    if (window.location.host.indexOf('localhost:300') === 0) return true;
    return false;
}
